<template lang="pug">
    div
        span(v-if="empty" slot="empty")
            i.text-muted No {{ subject }}

        span(v-if="single" slot="single")
            | {{ collection[0][label] }}

        span(v-if="multiple" slot="multiple")
            i {{ collection.length }} {{ subject }}

        span(v-if="all" slot="all")
            i All {{ subject }}
</template>

<script>
export default {
    props: {
        collection: {
            type: Array,
            required: false,
            default: () => [],
        },

        label: {
            type: String,
            required: false,
            default: 'name',
        },

        subject: {
            type: String,
            required: false,
            default: 'items',
        },

        total: {
            type: Number,
            required: false,
            default: -1,
        },
    },

    computed: {
        empty() {
            return this.collection != null && this.collection.length === 0;
        },

        single() {
            return !this.empty && this.collection.length === 1;
        },

        multiple() {
            return !this.empty && !this.all && this.collection.length > 1;
        },

        all() {
            return !this.empty && this.collection.length === this.total;
        },
    },
};
</script>
